<scaffold-json-editor *ngIf="item" [(json)]="item.value" [readonly]="true"></scaffold-json-editor>
